import { ICup, ILeagueContestants, IMatch } from "../../typings/typings";
import { League } from "./League";

export class Cup extends League implements ICup {
    public state: string;
    public prizePool;
    public contestants: ILeagueContestants;

    constructor(jsonData) {
        super(jsonData);
        this.state = jsonData.state;
        this.prizePool = jsonData.prizePool;
        this.contestants = jsonData.contestants;
    }

    public isFull() {
        if (
            typeof this.contestants !== "object" ||
            isNaN(this.contestants.max) ||
            this.contestants.max === null ||
            this.contestants.max === 0
        ) {
            return false;
        }
        return this.contestants.checkedIn >= this.contestants.max;
    }

    public isCheckInAvailable() {
        return typeof this.timeline === "object" && this.timeline.hasOwnProperty("checkIn");
    }

    public isSignUpAvailable() {
        return typeof this.timeline === "object" && this.timeline.hasOwnProperty("signUp") && this.timeline.signUp.begin;
    }

    public isPostSignUpAvailable() {
        return typeof this.timeline === "object" && this.timeline.hasOwnProperty("postSignUp");
    }

    public hasLateSignUp() {
        return typeof this.timeline === "object" && this.timeline.hasOwnProperty("lateSignUp");
    }

    public getStartDate(): Date {
        return typeof this.timeline === "object" && this.timeline.hasOwnProperty("inProgress")
            ? new Date(this.timeline.inProgress.begin)
            : new Date(0);
    }

    public getNextDate(): Date {
        if (
            this.state !== "finished" &&
            typeof this.timeline === "object" &&
            this.timeline.hasOwnProperty(this.state) &&
            this.timeline[this.state].hasOwnProperty("end")
        ) {
            return new Date(this.timeline[this.state].end);
        }
        return new Date(0);
    }

    public getState(): string {
        return this.state;
    }

    public getCurrentMatch(matches): IMatch {
        if (matches.open.length > 0) {
            return matches.open[0];
        }
        if (matches.challenge.length > 0) {
            return matches.challenge[0];
        }
        if (matches.protest.length > 0) {
            return matches.protest[0];
        }
        return null;
    }
}
